import { useSyncExternalStore } from "react"

const displayNamesByTestSetId = new Map<string, string>()
const listeners = new Set<() => void>()

function notify() {
  listeners.forEach((listener) => listener())
}

export function setLiveTestSetDisplayName(
  testSetId: string,
  displayName: string,
) {
  if (displayNamesByTestSetId.get(testSetId) === displayName) {
    return
  }
  displayNamesByTestSetId.set(testSetId, displayName)
  notify()
}

export function clearLiveTestSetDisplayName(testSetId: string) {
  if (displayNamesByTestSetId.delete(testSetId)) {
    notify()
  }
}

export function useLiveTestSetDisplayName(
  testSetId: string,
): string | undefined {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => displayNamesByTestSetId.get(testSetId),
    () => undefined,
  )
}
